document.addEventListener('click', function (event) {
  const next = event.target.closest('[data-scroll-next]');
  if (next) {
    const track = next.previousElementSibling;
    if (track) track.scrollBy({left: track.clientWidth * .75, behavior: 'smooth'});
  }
  const thumb = event.target.closest('[data-product-image]');
  if (thumb) {
    const image = document.getElementById('sl-main-product-image');
    if (image) { image.src = thumb.dataset.productImage; image.srcset = ''; }
    document.querySelectorAll('.sl-pdp__thumb').forEach(el => el.classList.toggle('is-active', el === thumb));
  }
});

(() => {
  const siteTop = document.querySelector('[data-site-top]');
  if (!siteTop) return;
  const header = siteTop.querySelector('[data-sd-header]');
  const triggers = [...siteTop.querySelectorAll('[data-mega-trigger]')];
  const panels = [...siteTop.querySelectorAll('[data-mega-panel]')];
  const mobileButton = siteTop.querySelector('[data-mobile-trigger]');
  const mobilePanel = siteTop.querySelector('#sd-mobile-nav');
  let closeTimer;
  const setScrolled = () => siteTop.classList.toggle('is-scrolled', window.scrollY > 90);
  const closeMega = () => {
    panels.forEach(panel => { panel.hidden = true; });
    triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    siteTop.classList.remove('is-open');
    delete siteTop.dataset.menu;
  };
  const openMega = name => {
    if (window.matchMedia('(max-width: 760px)').matches) return;
    window.clearTimeout(closeTimer);
    panels.forEach(panel => { panel.hidden = panel.dataset.megaPanel !== name; });
    triggers.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.megaTrigger === name)));
    siteTop.classList.add('is-open');
    siteTop.dataset.menu = name;
  };
  const plainLink = null;
  if (plainLink) {
    plainLink.addEventListener('mouseenter', () => {
      if (window.matchMedia('(max-width: 760px)').matches) return;
      closeMega();
      siteTop.dataset.menu = 'bestsellers';
    });
    plainLink.addEventListener('mouseleave', () => { if (siteTop.dataset.menu === 'bestsellers') delete siteTop.dataset.menu; });
  }
  triggers.forEach(button => {
    button.addEventListener('mouseenter', () => openMega(button.dataset.megaTrigger));
    button.addEventListener('focus', () => openMega(button.dataset.megaTrigger));
    button.addEventListener('click', () => {
      if (button.getAttribute('aria-expanded') === 'true') closeMega();
      else openMega(button.dataset.megaTrigger);
    });
  });
  header.addEventListener('mouseleave', () => { closeTimer = window.setTimeout(closeMega, 170); });
  header.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
  document.addEventListener('click', event => {
    if (!siteTop.contains(event.target)) {
      closeMega();
      if (mobilePanel) mobilePanel.hidden = true;
      if (mobileButton) mobileButton.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeMega();
      if (mobilePanel) mobilePanel.hidden = true;
      if (mobileButton) mobileButton.setAttribute('aria-expanded', 'false');
    }
  });
  if (mobileButton && mobilePanel) mobileButton.addEventListener('click', () => {
    const opening = mobilePanel.hidden;
    mobilePanel.hidden = !opening;
    mobileButton.setAttribute('aria-expanded', String(opening));
    siteTop.classList.toggle('is-open', opening);
    if (opening) siteTop.dataset.mc = 'furniture'; else { delete siteTop.dataset.mc; mobilePanel.querySelectorAll('details').forEach(g => { g.open = false; }); }
  });
  if (mobilePanel) {
    const groups = [...mobilePanel.querySelectorAll('details[data-mc]')];
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) {
        groups.forEach(other => { if (other !== group) other.open = false; });
        siteTop.dataset.mc = group.dataset.mc;
      } else if (!groups.some(other => other.open)) {
        siteTop.dataset.mc = 'furniture';
      }
    }));
  }
  window.addEventListener('resize', () => {
    if (window.innerWidth > 760 && mobilePanel) mobilePanel.hidden = true;
    else closeMega();
  });
  window.addEventListener('scroll', setScrolled, { passive: true });
  setScrolled();
  document.querySelectorAll('[data-shop-tab]').forEach(tab => tab.addEventListener('click', () => {
    const target = tab.dataset.shopTab;
    document.querySelectorAll('[data-shop-tab]').forEach(item => item.setAttribute('aria-selected', String(item === tab)));
    document.querySelectorAll('[data-shop-panel]').forEach(panel => { panel.hidden = panel.dataset.shopPanel !== target; });
  }));
  document.querySelectorAll('[data-hero-play]').forEach(button => {
    const video = button.closest('.sd-hero')?.querySelector('video');
    if (!video) { button.hidden = true; return; }
    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().then(() => {
          button.setAttribute('aria-label', 'Pause video');
          button.querySelector('span').textContent = 'Ⅱ';
        }).catch(() => {});
      } else {
        video.pause();
        button.setAttribute('aria-label', 'Play video');
        button.querySelector('span').textContent = '▶';
      }
    });
  });
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.body.classList.add('sd-motion');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    document.querySelectorAll('.sd-reveal').forEach(element => observer.observe(element));
  } else document.querySelectorAll('.sd-reveal').forEach(element => element.classList.add('is-visible'));
})();

// Sofa customizer: cushion stepper + custom-cart add (sofa + optional cushions in one request)
(() => {
  document.querySelectorAll('[data-cushion-stepper]').forEach(stepper => {
    const input = stepper.querySelector('.sl-stepper__input');
    const subtotal = stepper.querySelector('[data-cushion-subtotal]');
    const price = parseFloat(stepper.dataset.cushionPrice || '0');
    const formatMoney = n => '£' + n.toFixed(2);
    const render = () => {
      const qty = parseInt(input.value || '0', 10);
      subtotal.innerHTML = qty > 0 ? qty + ' × £25 = <strong>' + formatMoney(qty * price) + '</strong>' : '';
      minus.disabled = qty <= 0;
      plus.disabled = qty >= 10;
      input.classList.remove('is-pop'); void input.offsetWidth; input.classList.add('is-pop');
    };
    const minus = stepper.querySelector('[data-stepper-minus]');
    const plus = stepper.querySelector('[data-stepper-plus]');
    stepper.querySelector('[data-stepper-minus]').addEventListener('click', () => {
      input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
      render();
    });
    stepper.querySelector('[data-stepper-plus]').addEventListener('click', () => {
      input.value = Math.min(10, parseInt(input.value || '0', 10) + 1);
      render();
    });
    render();
  });

  document.querySelectorAll('[data-fabric-picker]').forEach(picker => {
    const modal = picker.querySelector('[data-fabric-modal]');
    const summary = picker.querySelector('[data-fabric-summary]');
    const openButton = picker.querySelector('[data-fabric-modal-open]');
    const closeButtons = picker.querySelectorAll('[data-fabric-modal-close]');
    const radios = picker.querySelectorAll('input[type=radio][name^="sl-fabric-swatch-"]');
    let lastFocus;

    const close = () => {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('sl-modal-open');
      if (lastFocus) lastFocus.focus();
    };

    const open = () => {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('sl-modal-open');
      const checked = picker.querySelector('input[type=radio][name^="sl-fabric-swatch-"]:checked');
      const focusTarget = checked || picker.querySelector('input[type=radio][name^="sl-fabric-swatch-"]') || modal.querySelector('[data-fabric-modal-close]');
      if (focusTarget) focusTarget.focus();
    };

    const render = radio => {
      if (!summary || !radio) return;
      const fabric = radio.dataset.fabric;
      const swatch = radio.dataset.swatch || radio.value;
      summary.textContent = fabric ? fabric + ' — ' + swatch : swatch;
      summary.classList.add('is-chosen');
      picker.classList.add('has-choice');
      const thumb = picker.querySelector('[data-fabric-thumb]');
      const source = radio.closest('.sl-fabric-swatch')?.querySelector('img');
      if (thumb && source) { thumb.src = source.src; thumb.hidden = false; thumb.classList.remove('is-placeholder'); }
    };

    if (openButton) openButton.addEventListener('click', open);
    closeButtons.forEach(button => button.addEventListener('click', close));
    radios.forEach(radio => radio.addEventListener('change', () => render(radio)));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && modal && !modal.hidden) close();
    });
  });

  const form = document.getElementById('sl-pdp-form');
  if (!form) return;
  form.addEventListener('submit', event => {
    event.preventDefault();
    const button = document.querySelector('.sl-add-to-cart');
    const errorEl = form.querySelector('[data-cart-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    const variantId = (form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[type=hidden][name="id"]'))?.value;
    const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);

    const properties = {};
    const footStyle = form.querySelector('input[type=radio][name^="sl-foot-style-"]:checked');
    if (footStyle) properties['Foot Style'] = footStyle.value.trim();

    const fabricSwatch = form.querySelector('input[type=radio][name^="sl-fabric-swatch-"]:checked');
    if (fabricSwatch) {
      if (fabricSwatch.dataset.fabric) properties['Fabric'] = fabricSwatch.dataset.fabric;
      properties['Swatch'] = fabricSwatch.dataset.swatch || fabricSwatch.value;
    }

    const sizeToggle = form.querySelector('.sl-custom-size-toggle');
    if (sizeToggle && sizeToggle.checked) {
      const width = form.querySelector('[id^="sl-custom-width-"]')?.value;
      const depth = form.querySelector('[id^="sl-custom-depth-"]')?.value;
      const height = form.querySelector('[id^="sl-custom-height-"]')?.value;
      if (width) properties['Custom Width (cm)'] = width;
      if (depth) properties['Custom Depth (cm)'] = depth;
      if (height) properties['Custom Height (cm)'] = height;
    }

    const missing = [];
    if (!fabricSwatch) missing.push('fabric');
    if (!footStyle) missing.push('foot');
    form.querySelectorAll('[data-error]').forEach(el => { el.hidden = !missing.includes(el.dataset.error); });
    if (missing.length) {
      const first = form.querySelector('[data-error="' + missing[0] + '"]');
      const block = first && (first.previousElementSibling || first);
      const target = missing[0] === 'fabric' ? form.querySelector('.sl-fabric-picker') : form.querySelector('.sl-foot-options')?.closest('.sl-customizer-block');
      const shake = target || block;
      if (shake) {
        shake.scrollIntoView({ behavior: 'smooth', block: 'center' });
        shake.classList.remove('is-shaking'); void shake.offsetWidth; shake.classList.add('is-shaking');
        setTimeout(() => shake.classList.remove('is-shaking'), 700);
      }
      return;
    }

    const group = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    properties['_group'] = group;
    const items = [{ id: variantId, quantity: quantity, properties: properties }];

    const stepper = form.querySelector('[data-cushion-stepper]');
    if (stepper) {
      const cushionQty = parseInt(stepper.querySelector('.sl-stepper__input')?.value || '0', 10);
      const cushionVariantId = stepper.dataset.cushionVariantId;
      if (cushionQty > 0 && cushionVariantId) items.push({ id: cushionVariantId, quantity: cushionQty });
    }

    const priceBox = document.querySelector('[data-price-box]');
    if (priceBox && sizeToggle && sizeToggle.checked && priceBox.dataset.extraVariantId) {
      const extraCm = ['width', 'depth', 'height'].reduce((sum, key) => {
        const input = form.querySelector('[id^="sl-custom-' + key + '-"]');
        const std = parseInt(input?.dataset.std || '0', 10);
        const val = parseInt(input?.value || '0', 10);
        return sum + (val > std ? val - std : 0);
      }, 0);
      if (extraCm > 0) items.push({ id: priceBox.dataset.extraVariantId, quantity: extraCm * quantity, properties: { '_group': group, '_per': String(extraCm), 'Custom size for': properties['Custom Width (cm)'] + ' x ' + properties['Custom Depth (cm)'] + ' x ' + properties['Custom Height (cm)'] + ' cm' } });
    }

    const seatBox = form.querySelector('[data-extra-seat]');
    if (seatBox && !seatBox.hidden) {
      const std = parseInt(seatBox.dataset.seatStd || '60', 10);
      let widthExtra = 0;
      seatBox.querySelectorAll('[data-seat-input]').forEach(input => {
        const n = parseInt(input.value || '0', 10);
        if (n < 1) return;
        const side = input.dataset.side;
        const wInput = seatBox.querySelector('[data-seat-width][data-side="' + side + '"]');
        const w = Math.min(120, Math.max(45, parseInt(wInput?.value || String(std), 10) || std));
        items.push({ id: seatBox.dataset.seatVariantId, quantity: n * quantity, properties: { '_group': group, '_per': String(n), 'Extra seat position': side, 'Extra seat width (cm)': String(w) } });
        if (w > std) widthExtra += (w - std) * n;
      });
      if (widthExtra > 0 && seatBox.dataset.cmVariantId) items.push({ id: seatBox.dataset.cmVariantId, quantity: widthExtra * quantity, properties: { '_group': group, '_per': String(widthExtra), 'Extra seat width adjustment': widthExtra + ' cm' } });
    }

    const look = form.querySelector('[data-look]');
    if (look && look.querySelector('[data-look-check]')?.checked && look.dataset.lookVariantId) {
      const lookProps = {};
      Object.keys(properties || {}).forEach(key => { if (/fabric|swatch/i.test(key)) lookProps[key] = properties[key]; });
      items.push({ id: look.dataset.lookVariantId, quantity: 1, properties: lookProps });
    }

    if (button) { button.disabled = true; button.dataset.originalText = button.textContent; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add this item to your bag.');
        window.location.href = '/cart';
      })
      .catch(error => {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = error.message; errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        if (button) { button.disabled = false; button.textContent = button.dataset.originalText; }
      });
  });
})();

document.addEventListener('change', event => {
  const select = event.target.closest('[data-seat-select]');
  if (select && select.value) window.location.href = select.value;
});

document.addEventListener('click', event => {
  const button = event.target.closest('[data-load-more]');
  if (!button) return;
  event.preventDefault();
  if (button.dataset.loading) return;
  const label = button.textContent;
  button.dataset.loading = 'true';
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Loading…';
  fetch(button.href)
    .then(response => { if (!response.ok) throw new Error('load failed'); return response.text(); })
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = button.closest('.sd-best-sellers').querySelector('.sd-best-sellers__grid');
      doc.querySelectorAll('.sd-best-sellers__grid > *').forEach(node => grid.appendChild(document.importNode(node, true)));
      const more = button.closest('.sd-best-sellers__more');
      const nextButton = doc.querySelector('[data-load-more]');
      if (!nextButton) { more.remove(); return; }
      const count = more.querySelector('[data-load-more-count]');
      const nextCount = doc.querySelector('[data-load-more-count]');
      if (count && nextCount) count.textContent = nextCount.textContent;
      button.href = nextButton.getAttribute('href');
      button.textContent = label;
      button.removeAttribute('aria-busy');
      delete button.dataset.loading;
    })
    .catch(() => { window.location.href = button.href; });
});

// Product page (mobile): swipeable gallery with counter, and a sticky add-to-bag bar
(() => {
  const gallery = document.querySelector('.sl-pdp__gallery');
  if (gallery) {
    const thumbs = [...gallery.querySelectorAll('.sl-pdp__thumb')];
    const main = gallery.querySelector('.sl-pdp__main-media');
    const mainImg = document.getElementById('sl-main-product-image');
    const counter = gallery.querySelector('[data-gallery-counter]');
    const sources = thumbs.map(t => t.dataset.productImage);
    let index = 0;
    let lightbox = null;

    const update = i => {
      index = i;
      if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      if (lightbox) lightbox.show(i);
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => update(i)));
    const go = i => {
      if (thumbs.length < 2) return;
      const next = (i + thumbs.length) % thumbs.length;
      thumbs[next].click();
      thumbs[next].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    };

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', event => { event.stopPropagation(); go(index - 1); });
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', event => { event.stopPropagation(); go(index + 1); });

    // swipe
    let startX = 0, startY = 0, tracking = false;
    if (main) {
      main.addEventListener('touchstart', event => {
        const touch = event.touches[0];
        startX = touch.clientX; startY = touch.clientY; tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', event => {
        if (!tracking) return;
        tracking = false;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - startX, dy = touch.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      // hover zoom (mouse only)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && mainImg) {
        main.addEventListener('mousemove', event => {
          const r = main.getBoundingClientRect();
          mainImg.style.transformOrigin = ((event.clientX - r.left) / r.width * 100) + '% ' + ((event.clientY - r.top) / r.height * 100) + '%';
          main.classList.add('is-zooming');
        });
        main.addEventListener('mouseleave', () => main.classList.remove('is-zooming'));
      }
    }

    // keyboard on the gallery
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') go(index - 1);
      if (event.key === 'ArrowRight') go(index + 1);
    });

    // full-screen viewer
    const openLightbox = () => {
      if (lightbox) return;
      const root = document.createElement('div');
      root.className = 'sl-lightbox';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', 'Product images');
      root.innerHTML =
        '<button type="button" class="sl-lightbox__close" aria-label="Close">×</button>' +
        (sources.length > 1 ? '<button type="button" class="sl-lightbox__nav sl-lightbox__nav--prev" aria-label="Previous image"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button><button type="button" class="sl-lightbox__nav sl-lightbox__nav--next" aria-label="Next image"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' : '') +
        '<div class="sl-lightbox__stage"><img alt=""></div>' +
        (sources.length > 1 ? '<div class="sl-lightbox__count"></div>' : '');
      document.body.appendChild(root);
      document.documentElement.classList.add('sl-modal-open');
      const img = root.querySelector('img');
      const count = root.querySelector('.sl-lightbox__count');
      const show = i => {
        img.classList.remove('is-in'); void img.offsetWidth;
        img.src = sources[i] || mainImg.src;
        img.classList.add('is-in');
        if (count) count.textContent = (i + 1) + ' / ' + sources.length;
      };
      const close = () => {
        document.removeEventListener('keydown', onKey);
        root.classList.add('is-out');
        setTimeout(() => root.remove(), 200);
        document.documentElement.classList.remove('sl-modal-open');
        lightbox = null;
      };
      const onKey = event => {
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowLeft') go(index - 1);
        if (event.key === 'ArrowRight') go(index + 1);
      };
      document.addEventListener('keydown', onKey);
      root.addEventListener('click', event => {
        if (event.target.closest('.sl-lightbox__close') || event.target === root || event.target.classList.contains('sl-lightbox__stage')) close();
        if (event.target.closest('.sl-lightbox__nav--prev')) go(index - 1);
        if (event.target.closest('.sl-lightbox__nav--next')) go(index + 1);
      });
      let lx = 0;
      root.addEventListener('touchstart', e => { lx = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - lx; if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1)); }, { passive: true });
      lightbox = { show };
      show(index);
      root.querySelector('.sl-lightbox__close').focus();
    };
    gallery.querySelector('[data-gallery-zoom]')?.addEventListener('click', event => { event.stopPropagation(); openLightbox(); });
    main?.addEventListener('click', event => { if (!event.target.closest('button')) openLightbox(); });
  }

  const sticky = document.querySelector('[data-sticky-atc]');
  const target = document.querySelector('.sl-add-to-cart');
  if (!sticky || !target) return;
  const stickyButton = sticky.querySelector('[data-sticky-atc-button]');
  stickyButton.addEventListener('click', () => target.click());
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting)).observe(target);
  } else sticky.classList.add('is-visible');
  const sync = () => {
    stickyButton.disabled = target.disabled && !/^Adding/.test(target.textContent);
    stickyButton.textContent = /^Adding/.test(target.textContent) ? 'Adding…' : (target.disabled ? 'Sold out' : 'Add to bag');
  };
  new MutationObserver(sync).observe(target, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
})();

(function () {
  const fav = document.querySelector('[data-fav]');
  if (!fav) return;
  const key = 'sl-favourites';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } };
  const render = () => { const on = read().includes(fav.dataset.fav); fav.setAttribute('aria-pressed', on); fav.classList.toggle('is-on', on); };
  fav.addEventListener('click', () => {
    const list = read(), h = fav.dataset.fav, i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    render();
  });
  render();
})();

(function () {
  const page = document.querySelector('[data-fav-page]');
  if (!page) return;
  const grid = page.querySelector('[data-fav-grid]');
  const empty = page.querySelector('[data-fav-empty]');
  const key = 'sl-favourites';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } };
  const write = list => { try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {} };
  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP', maximumFractionDigits: 0 }).format(cents / 100);
  const esc = str => String(str).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const showEmpty = () => { empty.hidden = grid.children.length > 0; };

  read().forEach(handle => {
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(p => {
        const card = document.createElement('article');
        card.className = 'sl-fav-card';
        card.dataset.handle = handle;
        card.innerHTML =
          '<a class="sl-fav-card__link" href="' + esc(p.url) + '"><span class="sl-fav-card__media">' + (p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span>' +
          '<span class="sl-fav-card__title">' + esc(p.title) + '</span><span class="sl-fav-card__price">' + money(p.price) + '</span></a>' +
          '<button type="button" class="sl-fav-card__remove" aria-label="Remove from favourites"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.1 3.3 5 6.6 5c2 0 3.6 1.1 5.4 3.1C13.8 6.1 15.4 5 17.4 5c3.3 0 5.1 3.1 3.9 6.3-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg></button>';
        card.querySelector('button').addEventListener('click', () => {
          write(read().filter(h => h !== handle));
          card.remove();
          showEmpty();
        });
        grid.appendChild(card);
        showEmpty();
      })
      .catch(() => { write(read().filter(h => h !== handle)); showEmpty(); });
  });
  showEmpty();
})();

(function () {
  const group = document.querySelector('.sl-foot-options');
  if (!group) return;
  const current = document.querySelector('[data-foot-current]');
  group.addEventListener('change', event => {
    const input = event.target.closest('input[type=radio]');
    if (!input) return;
    if (current) { current.textContent = input.value.trim(); current.classList.remove('is-bump'); void current.offsetWidth; current.classList.add('is-bump'); }
    const tile = input.closest('.sl-foot-option');
    if (tile && group.scrollWidth > group.clientWidth) tile.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });
})();

document.addEventListener('change', event => {
  const t = event.target;
  if (!t.matches) return;
  if (t.matches('input[name^="sl-fabric-swatch-"]')) document.querySelectorAll('[data-error="fabric"]').forEach(el => { el.hidden = true; });
  if (t.matches('input[name^="sl-foot-style-"]')) {
    document.querySelectorAll('[data-error="foot"]').forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-foot-current]').forEach(el => el.classList.remove('is-empty'));
  }
});

// Collection listing: instant filters, sort, drawer, favourites on cards
(function () {
  const root = document.querySelector('[data-plp]');
  if (!root) return;
  const grid = root.querySelector('[data-plp-grid]');
  const groupsEl = root.querySelector('[data-filter-groups]');
  const chipsEl = root.querySelector('[data-chips]');
  const countEl = root.querySelector('[data-count]');
  const emptyEl = root.querySelector('[data-empty]');
  const badge = root.querySelector('[data-badge]');
  const applyCount = root.querySelector('[data-apply-count]');
  const sortEl = root.querySelector('[data-sort]');
  const storeKey = 'sl-plp-' + root.dataset.collection;

  const LAYOUT = { 'layout-armchair': 'Armchair', 'layout-2-seater': '2 Seater', 'layout-3-seater': '3 Seater', 'layout-4-seater': '4 Seater', 'layout-corner': 'Corner', 'layout-chaise': 'Chaise', 'layout-u-shape': 'U-Shape', 'layout-set-3-2': '3+2 Set' };
  const COLOUR = { Black: '#1b1b1b', Blue: '#2f5d8a', Cream: '#efe6d2', Grey: '#8b8b8b', Beige: '#cdb99a', White: '#f7f7f7', Mink: '#8a7667', 'Steel Grey': '#6c7684', 'Dark Charcoal': '#363a40' };
  const FACETS = [
    { key: 'layout', title: 'Sofa type', label: v => LAYOUT[v] || v.replace('layout-', '') },
    { key: 'range', title: 'Range', label: v => v },
    { key: 'colour', title: 'Colour', label: v => v, dot: v => COLOUR[v] },
    { key: 'fabric', title: 'Fabric', label: v => v }
  ];
  const state = { layout: new Set(), range: new Set(), colour: new Set(), fabric: new Set(), min: '', max: '' };
  let items = [];
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = n => '£' + Number(n).toLocaleString('en-GB');
  const vals = (el, key) => (el.dataset[key] || '').split('|').map(s => s.trim()).filter(Boolean);

  const collect = () => {
    items = [...grid.querySelectorAll('.sl-plp__item')].map(el => ({
      el,
      index: +el.dataset.index || 0,
      title: el.dataset.title || '',
      price: +el.dataset.price || 0,
      created: +el.dataset.created || 0,
      layout: vals(el, 'layout'),
      range: vals(el, 'range'),
      colour: vals(el, 'colour'),
      fabric: vals(el, 'fabric')
    }));
  };

  const matches = (it, skip) => {
    for (const f of FACETS) {
      if (f.key === skip) continue;
      const set = state[f.key];
      if (set.size && !it[f.key].some(v => set.has(v))) return false;
    }
    if (state.min !== '' && it.price < +state.min) return false;
    if (state.max !== '' && it.price > +state.max) return false;
    return true;
  };

  const buildGroups = () => {
    let html = '';
    FACETS.forEach(f => {
      const counts = new Map();
      items.forEach(it => it[f.key].forEach(v => counts.set(v, (counts.get(v) || 0) + 1)));
      if (counts.size < 2) return;
      const entries = [...counts.entries()].sort((a, b) => f.key === 'layout' ? Object.keys(LAYOUT).indexOf(a[0]) - Object.keys(LAYOUT).indexOf(b[0]) : b[1] - a[1]);
      html += '<details class="sl-fgroup" open><summary>' + f.title + '</summary><div class="sl-fgroup__body' + (f.dot ? ' is-dots' : '') + '">' +
        entries.map(([v, n]) => '<label class="sl-fchk"><input type="checkbox" data-facet="' + f.key + '" value="' + esc(v) + '"' + (state[f.key].has(v) ? ' checked' : '') + '>' +
          (f.dot ? '<span class="sl-fchk__dot" style="--c:' + (f.dot(v) || '#ccc') + '"></span>' : '<span class="sl-fchk__box"></span>') +
          '<span class="sl-fchk__label">' + esc(f.label(v)) + '</span><span class="sl-fchk__count" data-count-for="' + f.key + '|' + esc(v) + '">' + n + '</span></label>').join('') +
        '</div></details>';
    });
    const prices = items.map(i => i.price).filter(Boolean);
    if (prices.length && Math.min(...prices) !== Math.max(...prices)) {
      html += '<details class="sl-fgroup" open><summary>Price</summary><div class="sl-fgroup__body sl-price"><label><span>From £</span><input type="number" inputmode="numeric" min="0" data-price-input="min" placeholder="' + Math.min(...prices) + '" value="' + state.min + '"></label><label><span>To £</span><input type="number" inputmode="numeric" min="0" data-price-input="max" placeholder="' + Math.max(...prices) + '" value="' + state.max + '"></label></div></details>';
    }
    groupsEl.innerHTML = html;
    root.classList.toggle('has-no-filters', !html);
  };

  const save = () => {
    try { sessionStorage.setItem(storeKey, JSON.stringify({ layout: [...state.layout], range: [...state.range], colour: [...state.colour], fabric: [...state.fabric], min: state.min, max: state.max, sort: sortEl.value })); } catch (e) {}
  };
  const restore = () => {
    try {
      const s = JSON.parse(sessionStorage.getItem(storeKey) || 'null');
      if (!s) return;
      FACETS.forEach(f => { state[f.key] = new Set(s[f.key] || []); });
      state.min = s.min || ''; state.max = s.max || '';
      if (s.sort) sortEl.value = s.sort;
    } catch (e) {}
  };

  const sorters = {
    featured: (a, b) => a.index - b.index,
    'price-asc': (a, b) => a.price - b.price,
    'price-desc': (a, b) => b.price - a.price,
    name: (a, b) => a.title.localeCompare(b.title),
    new: (a, b) => b.created - a.created
  };

  const activeCount = () => FACETS.reduce((n, f) => n + state[f.key].size, 0) + (state.min !== '' ? 1 : 0) + (state.max !== '' ? 1 : 0);

  const render = () => {
    const sorted = [...items].sort(sorters[sortEl.value] || sorters.featured);
    let shown = 0;
    sorted.forEach(it => {
      const ok = matches(it);
      it.el.hidden = !ok;
      grid.appendChild(it.el);
      if (ok) shown++;
    });
    const total = items.length;
    const filtered = activeCount() > 0;
    const more = !!root.querySelector('[data-plp-next]');
    const all = Math.max(+root.dataset.total || 0, total);
    countEl.textContent = filtered ? 'Showing ' + shown + ' of ' + (more ? all : total) + ' sofas' : (more ? all : total) + ((more ? all : total) === 1 ? ' sofa' : ' sofas');
    if (applyCount) applyCount.textContent = shown + (shown === 1 ? ' sofa' : ' sofas');
    emptyEl.hidden = shown !== 0;
    const n = activeCount();
    if (badge) { badge.hidden = !n; badge.textContent = n; }

    // live counts per option (respecting the other facets)
    groupsEl.querySelectorAll('[data-count-for]').forEach(span => {
      const [key, value] = span.dataset.countFor.split('|');
      span.textContent = items.filter(it => matches(it, key) && it[key].includes(value)).length;
      span.closest('.sl-fchk').classList.toggle('is-zero', span.textContent === '0');
    });

    // chips
    let chips = '';
    FACETS.forEach(f => state[f.key].forEach(v => { chips += '<button type="button" class="sl-chip" data-remove="' + f.key + '|' + esc(v) + '">' + esc(f.label(v)) + '<span aria-hidden="true">×</span></button>'; }));
    if (state.min !== '' || state.max !== '') chips += '<button type="button" class="sl-chip" data-remove="price|">' + (state.min !== '' ? money(state.min) : 'Any') + ' – ' + (state.max !== '' ? money(state.max) : 'Any') + '<span aria-hidden="true">×</span></button>';
    if (chips) chips += '<button type="button" class="sl-chip sl-chip--clear" data-clear>Clear all</button>';
    chipsEl.innerHTML = chips;
    root.classList.toggle('is-filtered', filtered);
    save();
  };

  const clearAll = () => { FACETS.forEach(f => state[f.key].clear()); state.min = ''; state.max = ''; groupsEl.querySelectorAll('input[type=checkbox]').forEach(i => { i.checked = false; }); groupsEl.querySelectorAll('[data-price-input]').forEach(i => { i.value = ''; }); render(); };

  // events
  root.addEventListener('change', event => {
    const t = event.target;
    if (t.matches('input[data-facet]')) { state[t.dataset.facet][t.checked ? 'add' : 'delete'](t.value); render(); if (typeof loadAll === 'function' && nextLink()) loadAll(); }
    if (t === sortEl) render();
  });
  root.addEventListener('input', event => {
    const t = event.target;
    if (t.matches('[data-price-input]')) { state[t.dataset.priceInput] = t.value === '' ? '' : Math.max(0, +t.value); render(); if (typeof loadAll === 'function' && nextLink()) loadAll(); }
  });
  root.addEventListener('click', event => {
    const clear = event.target.closest('[data-clear]');
    if (clear) { clearAll(); return; }
    const rm = event.target.closest('[data-remove]');
    if (rm) {
      const [key, value] = rm.dataset.remove.split('|');
      if (key === 'price') { state.min = ''; state.max = ''; groupsEl.querySelectorAll('[data-price-input]').forEach(i => { i.value = ''; }); }
      else { state[key].delete(value); const box = [...groupsEl.querySelectorAll('input[data-facet="' + key + '"]')].find(i => i.value === value); if (box) box.checked = false; }
      render();
      return;
    }
    if (event.target.closest('[data-filters-open]')) { document.documentElement.classList.add('sl-filters-open'); }
    if (event.target.closest('[data-filters-close]')) { document.documentElement.classList.remove('sl-filters-open'); }
    const fav = event.target.closest('[data-fav-card]');
    if (fav) {
      event.preventDefault();
      const key = 'sl-favourites';
      let list = []; try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
      const h = fav.dataset.favCard, i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      paintFavs();
      fav.classList.add('is-pop'); setTimeout(() => fav.classList.remove('is-pop'), 400);
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.documentElement.classList.remove('sl-filters-open'); });

  const paintFavs = () => {
    let list = []; try { list = JSON.parse(localStorage.getItem('sl-favourites') || '[]'); } catch (e) {}
    grid.querySelectorAll('[data-fav-card]').forEach(b => { const on = list.includes(b.dataset.favCard); b.setAttribute('aria-pressed', on); b.classList.toggle('is-on', on); });
  };

  const applyUrl = () => {
    const qs = new URLSearchParams(location.search);
    let any = false;
    FACETS.forEach(f => { const v = qs.getAll(f.key).join(',').split(',').map(x => x.trim()).filter(Boolean); if (v.length) { if (!any) { FACETS.forEach(g => state[g.key].clear()); state.min = ''; state.max = ''; any = true; } state[f.key] = new Set(v); } });
    if (qs.get('min')) { state.min = +qs.get('min'); any = true; }
    if (qs.get('max')) { state.max = +qs.get('max'); any = true; }
  };
  const init = () => { collect(); restore(); applyUrl(); buildGroups(); render(); paintFavs(); };

  // paging: "Load more" button; filters/sorting quietly load everything first
  const moreBox = root.querySelector('[data-more]');
  const moreBtn = root.querySelector('[data-load-more-plp]');
  const moreStatus = root.querySelector('[data-more-status]');
  const moreBar = root.querySelector('[data-more-bar]');
  const total = () => +root.dataset.total || items.length;
  const nextLink = () => root.querySelector('[data-plp-next]');
  let busy = null;

  const updateMore = () => {
    const has = !!nextLink();
    if (moreBox) moreBox.hidden = !has;
    const have = items.length, all = Math.max(total(), have);
    if (moreStatus) moreStatus.textContent = 'Showing ' + have + ' of ' + all + ' sofas';
    if (moreBar) moreBar.style.width = Math.min(100, Math.round(have / all * 100)) + '%';
  };

  const loadNext = () => {
    if (busy) return busy;
    const link = nextLink();
    if (!link) return Promise.resolve(false);
    root.classList.add('is-loading');
    if (moreBtn) { moreBtn.disabled = true; moreBtn.textContent = 'Loading…'; }
    busy = fetch(link.getAttribute('href'))
      .then(r => { if (!r.ok) throw new Error('load failed'); return r.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const base = items.length;
        const added = [];
        doc.querySelectorAll('.sl-plp__item').forEach((n, i) => { const node = document.importNode(n, true); node.dataset.index = base + i + 1; grid.appendChild(node); added.push(node); });
        const nextDoc = doc.querySelector('[data-plp-next]');
        link.remove();
        if (nextDoc) root.querySelector('.sl-plp__main').insertBefore(document.importNode(nextDoc, true), moreBox);
        collect(); buildGroups(); render(); paintFavs(); updateMore();
        added.forEach((n, i) => { n.classList.add('is-new'); n.style.animationDelay = (i * 40) + 'ms'; });
        return true;
      })
      .catch(() => false)
      .finally(() => {
        busy = null;
        root.classList.remove('is-loading');
        if (moreBtn) { moreBtn.disabled = false; moreBtn.textContent = 'Load more sofas'; }
      });
    return busy;
  };

  const loadAll = async () => {
    let guard = 0;
    while (nextLink() && guard++ < 10) { const ok = await loadNext(); if (!ok) break; }
  };

  moreBtn?.addEventListener('click', () => loadNext());

  // anything that needs the full list loads the rest first
  let preloaded = false;
  const preload = () => { if (preloaded) return; preloaded = true; loadAll(); };
  ['pointerdown', 'focusin'].forEach(evt => root.querySelector('.sl-filters')?.addEventListener(evt, preload, { once: true }));
  root.querySelector('[data-filters-open]')?.addEventListener('pointerdown', preload, { once: true });
  sortEl.addEventListener('focus', preload, { once: true });
  sortEl.addEventListener('change', () => { if (sortEl.value !== 'featured') loadAll().then(render); });

  init();
  updateMore();
  if (activeCount() > 0 || sortEl.value !== 'featured') loadAll().then(() => { buildGroups(); render(); });
})();

document.addEventListener('click', event => {
  const btn = event.target.closest('[data-rail-step]');
  if (!btn) return;
  const rail = btn.closest('[data-rail]');
  const track = rail && rail.querySelector('[data-rail-track]');
  if (!track) return;
  const card = track.querySelector('.sd-rail__card');
  const step = (card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .8) * (+btn.dataset.railStep);
  track.scrollBy({ left: step, behavior: 'smooth' });
});
(function () {
  document.querySelectorAll('[data-rail]').forEach(rail => {
    const track = rail.querySelector('[data-rail-track]');
    const prev = rail.querySelector('.sd-rail__arrow--prev'), next = rail.querySelector('.sd-rail__arrow--next');
    if (!track) return;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-off', track.scrollLeft >= max);
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

(function () {
  const strip = document.querySelector('[data-strip]');
  if (!strip) return;
  const raw = strip.dataset.end;
  if (!raw) return;
  const end = new Date(raw.trim().replace(' ', 'T') + (raw.trim().length <= 10 ? 'T23:59:00' : ':00'));
  if (isNaN(end)) return;
  const count = strip.querySelector('[data-strip-count]');
  const d = strip.querySelector('[data-strip-d]'), h = strip.querySelector('[data-strip-h]'), m = strip.querySelector('[data-strip-m]');
  const pad = n => String(n).padStart(2, '0');
  const tick = () => {
    const ms = end - Date.now();
    if (ms <= 0) { strip.hidden = true; document.documentElement.classList.add('sd-strip-gone'); return false; }
    const mins = Math.floor(ms / 60000);
    d.textContent = pad(Math.floor(mins / 1440));
    h.textContent = pad(Math.floor(mins % 1440 / 60));
    m.textContent = pad(mins % 60);
    if (count) count.hidden = false;
    return true;
  };
  if (tick()) setInterval(tick, 20000);
})();

(function () {
  const hero = document.querySelector('.sd-hero');
  const top = document.querySelector('[data-site-top]');
  if (!hero || !top || !document.querySelector('[data-strip]')) return;
  const update = () => top.classList.toggle('is-past-hero', hero.getBoundingClientRect().bottom <= 96);
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

(function () {
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce) return;
  document.querySelectorAll('[data-tilt]').forEach(card => {
    let raf = 0;
    card.addEventListener('pointermove', e => {
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        card.style.setProperty('--rx', (py * -14).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (px * 16).toFixed(2) + 'deg');
        card.style.setProperty('--mx', ((px + .5) * 100).toFixed(1) + '%');
        card.style.setProperty('--my', ((py + .5) * 100).toFixed(1) + '%');
      });
    });
    card.addEventListener('pointerleave', () => {
      cancelAnimationFrame(raf);
      card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
    });
  });
})();


// Custom size: live price update and confirmation message
(() => {
  const box = document.querySelector('[data-price-box]');
  const card = document.querySelector('[data-custom-size]');
  if (!box || !card) return;
  const toggle = card.querySelector('.sl-custom-size-toggle');
  const inputs = ['width', 'depth', 'height'].map(key => card.querySelector('[id^="sl-custom-' + key + '-"]'));
  const note = card.querySelector('[data-custom-size-note]');
  const baseNote = note ? note.textContent : '';
  const variantInputs = [...document.querySelectorAll('input[name="id"][data-price]')];
  const variantSelect = document.querySelector('select[name="id"]');
  const selectedVariant = () => document.querySelector('input[name="id"][data-price]:checked') || (variantSelect && variantSelect.selectedOptions[0]) || null;
  const basePenceNow = () => { const v = selectedVariant(); return parseInt((v && v.dataset.price) || box.dataset.basePrice || '0', 10); };
  const perCm = parseFloat(box.dataset.perCm || '5');
  const gbp = n => '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const gbp0 = n => '£' + n.toLocaleString('en-GB', { maximumFractionDigits: 0 });
  const nowEl = document.querySelector('.sl-pdp__now');
  const wasEl = document.querySelector('.sl-pdp__was');
  const saveEl = document.querySelector('.sl-pdp__save');
  const stickyEl = document.querySelector('.sl-sticky-atc__price');
  const klarnaEl = document.querySelector('.sl-pdp__klarna strong');
  const seatBox = document.querySelector('[data-extra-seat]');
  const seatInputs = seatBox ? [...seatBox.querySelectorAll('[data-seat-input]')] : [];
  const seatNote = seatBox && seatBox.querySelector('[data-seat-note]');
  let seatPrice = seatBox ? parseFloat(seatBox.dataset.seatPrice || '0') : 0;
  const dimEls = { w: document.querySelectorAll('[data-dim="w"]'), d: document.querySelectorAll('[data-dim="d"]'), h: document.querySelectorAll('[data-dim="h"]') };
  const update = () => {
    let extra = 0;
    const vals = inputs.map(input => {
      const std = parseInt(input?.dataset.std || '0', 10);
      const raw = parseInt(input?.value || '0', 10);
      const val = toggle.checked && raw > 0 ? raw : std;
      if (val > std) extra += val - std;
      return val;
    });
    const seats = seatInputs.reduce((sum, input) => sum + parseInt(input.value || '0', 10), 0);
    const seatStd = seatBox ? parseInt(seatBox.dataset.seatStd || '60', 10) : 60;
    const seatCm = seatBox ? seatInputs.reduce((sum, input) => { const n = parseInt(input.value || '0', 10); const w = seatBox.querySelector('[data-seat-width][data-side="' + input.dataset.side + '"]'); const v = Math.min(120, Math.max(45, parseInt(w && w.value || String(seatStd), 10) || seatStd)); return sum + (n > 0 && v > seatStd ? (v - seatStd) * n : 0); }, 0) : 0;
    const price = basePenceNow() / 100 + extra * perCm + seats * seatPrice + seatCm * perCm;
    const was = Math.round(price * 1.3 / 100) * 100;
    if (nowEl) nowEl.textContent = gbp(price);
    if (wasEl) wasEl.textContent = gbp0(was);
    if (saveEl) saveEl.textContent = 'Save ' + gbp(was - price);
    if (stickyEl) stickyEl.textContent = gbp0(price);
    if (klarnaEl) klarnaEl.textContent = gbp0(Math.round(price / 12)) + '/month';
    ['w', 'd', 'h'].forEach((k, i) => dimEls[k].forEach(el => { el.textContent = vals[i] + ' cm'; }));
    if (seatNote) {
      seatNote.hidden = seats < 1;
      seatNote.classList.toggle('is-confirm', seats > 0);
      const sides = seatInputs.filter(input => parseInt(input.value || '0', 10) > 0).map(input => { const w = seatBox.querySelector('[data-seat-width][data-side="' + input.dataset.side + '"]'); return input.value + ' on the ' + input.dataset.side.toLowerCase() + ' (' + (w ? w.value : 60) + ' cm each)'; }).join(', ');
      seatNote.innerHTML = seats > 0 ? '<strong>' + (seats === 1 ? 'Extra seat added' : seats + ' extra seats added') + ' (' + sides + ').</strong> ' + 'Your new price is <strong>' + gbp(price) + '</strong>.' : '';
    }
    if (note) {
      note.classList.toggle('is-confirm', toggle.checked && extra > 0);
      note.innerHTML = toggle.checked && extra > 0
        ? '<strong>Custom size added.</strong> Your new price is <strong>' + gbp(price) + '</strong>.'
        : baseNote;
    }
  };
  if (seatBox) {
    const MAX_TOTAL = 4;
    const total = () => seatInputs.reduce((sum, input) => sum + parseInt(input.value || '0', 10), 0);
    const refresh = () => seatBox.querySelectorAll('.sl-seat__row').forEach(row => {
      const input = row.querySelector('[data-seat-input]');
      row.querySelector('[data-seat-minus]').disabled = parseInt(input.value, 10) <= 0;
      row.querySelector('[data-seat-plus]').disabled = total() >= MAX_TOTAL;
      const cm = row.querySelector('[data-seat-cm]'); if (cm) cm.hidden = parseInt(input.value, 10) <= 0;
    });
    seatBox.querySelectorAll('.sl-seat__row').forEach(row => {
      const input = row.querySelector('[data-seat-input]');
      row.querySelector('[data-seat-minus]').addEventListener('click', () => { input.value = Math.max(0, parseInt(input.value, 10) - 1); refresh(); update(); });
      row.querySelector('[data-seat-plus]').addEventListener('click', () => { if (total() < MAX_TOTAL) { input.value = parseInt(input.value, 10) + 1; refresh(); update(); } });
    });
  }
  const syncSeatForVariant = () => {
    if (!seatBox) return;
    const v = selectedVariant();
    const price = (v && v.dataset.seatPrice) || seatBox.dataset.seatDefault || '250';
    const table = Object.fromEntries((seatBox.dataset.seatTable || '').split(';').filter(Boolean).map(pair => pair.split(':')));
    seatPrice = price ? parseFloat(price) : 0;
    seatBox.dataset.seatPrice = price;
    seatBox.dataset.seatVariantId = table[price] || '';
    const label = seatBox.querySelector('[data-seat-label]');
    if (label) label.textContent = '(+£' + price + ' each)';
  };
  variantInputs.forEach(input => input.addEventListener('change', () => { syncSeatForVariant(); update(); }));
  if (variantSelect) variantSelect.addEventListener('change', () => { syncSeatForVariant(); update(); });
  if (seatBox) seatBox.querySelectorAll('[data-seat-custom]').forEach(btn => btn.addEventListener('click', () => { const row = btn.closest('.sl-seat__cm'); const box = row.querySelector('[data-seat-cmbox]'); box.hidden = !box.hidden; btn.textContent = box.hidden ? 'Customise width' : 'Use standard'; if (box.hidden) { box.querySelector('input').value = seatBox.dataset.seatStd || 60; update(); } else box.querySelector('input').focus(); }));
  if (seatBox) seatBox.querySelectorAll('[data-seat-width]').forEach(i => i.addEventListener('input', update));
  inputs.forEach(input => input && input.addEventListener('input', update));
  toggle.addEventListener('change', update);
  update();
})();


// Cart page: live quantity changes, linked add-ons and totals
(() => {
  const root = document.querySelector('[data-cart]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const setBadge = count => {
    document.querySelectorAll('a[href$="/cart"]').forEach(link => {
      if (!link.closest('.sd-header__actions')) return;
      let badge = link.querySelector('small');
      if (count > 0) { if (!badge) { badge = document.createElement('small'); link.appendChild(badge); } badge.textContent = count; }
      else if (badge) badge.remove();
    });
  };
  const render = async () => {
    const res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId));
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
    const next = doc.querySelector('[data-cart]');
    if (next) root.innerHTML = next.innerHTML;
  };
  const apply = async (key, qty) => {
    const item = root.querySelector('[data-key="' + CSS.escape(key) + '"]');
    if (item) item.classList.add('is-busy');
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const line = cart.items.find(i => i.key === key);
      const updates = {};
      updates[key] = qty;
      if (line && line.properties && line.properties._group && !line.properties._per) {
        cart.items.forEach(other => {
          if (other.key !== key && other.properties && other.properties._group === line.properties._group && other.properties._per) {
            updates[other.key] = parseInt(other.properties._per, 10) * qty;
          }
        });
      }
      const res = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      const updated = await res.json();
      setBadge(updated.items.reduce((sum, i) => sum + (i.properties && i.properties._per ? 0 : i.quantity), 0));
      await render();
    } catch (e) {
      window.location.reload();
    }
  };
  let timer;
  root.addEventListener('click', event => {
    const row = event.target.closest('[data-cart-item]');
    if (!row) return;
    const input = row.querySelector('[data-cart-input]');
    const current = parseInt(row.dataset.qty || '1', 10);
    if (event.target.closest('[data-cart-plus]')) { event.preventDefault(); apply(row.dataset.key, current + 1); }
    else if (event.target.closest('[data-cart-minus]')) { event.preventDefault(); apply(row.dataset.key, Math.max(0, current - 1)); }
    else if (event.target.closest('[data-cart-remove]')) { event.preventDefault(); apply(row.dataset.key, 0); }
  });
  root.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-input]');
    if (!input) return;
    const row = input.closest('[data-cart-item]');
    window.clearTimeout(timer);
    timer = window.setTimeout(() => apply(row.dataset.key, Math.max(0, parseInt(input.value || '0', 10))), 250);
  });
  root.addEventListener('submit', event => {
    if (event.submitter && event.submitter.name === 'update') event.preventDefault();
  });
})();
